import { saveProgress } from '@brainstud/react-tbl/features/account/store'

/* -------------------------------------------------- */

export const loadProgressSuccess = payload => {
  return { type: 'CHAPTERS_LOAD_PROGRESS_SUCCESS', payload }
}

export const loadProgress = data => {
  return (dispatch, getState) => {
    dispatch(loadProgressSuccess(data))
  }
}

/* -------------------------------------------------- */

export const setProgressSuccess = payload => {
  return { type: 'CHAPTERS_SET_PROGRESS_SUCCESS', payload }
}

export const setProgress = params => {
  return (dispatch, getState) => {
    dispatch(setProgressSuccess(params))
    dispatch(saveProgress())
  }
}

/* -------------------------------------------------- */
